export const outboundRecordTypeValues = ['SHIPMENT', 'COVER_SHIPMENT'] as const;
export type OutboundRecordType = (typeof outboundRecordTypeValues)[number];

export interface OutboundRecordReference {
  outboundRecordType: OutboundRecordType;
  outboundRecordId: string;
}

export function toShipmentOutboundRecordReference(shipmentId: string): OutboundRecordReference {
  return {
    outboundRecordType: 'SHIPMENT',
    outboundRecordId: shipmentId,
  };
}

export function toCoverShipmentOutboundRecordReference(
  coverShipmentId: string,
): OutboundRecordReference {
  return {
    outboundRecordType: 'COVER_SHIPMENT',
    outboundRecordId: coverShipmentId,
  };
}
